import axios from 'axios'

const Solr = axios.create({
  baseURL: 'https://api.formular.dev.transparex.sk/search',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

export default Solr
